export default function DWorkLogo() {
  return (
    <div className="relative size-full" data-name="디웍로고">
      <img src="/svg/dwork_text_logo.svg" alt="DW.Insights" className="block size-full" />
    </div>
  );
}
